
import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Options({})
export default class ConfirmModal extends Vue {

    @Prop() title: string;
    @Prop() text: string;
    @Prop({
        default: 'OK'
    }) okText: string;
    @Prop({
        default: 'Annulla'
    }) koText: string;
    @Prop({
        default: 'Scrivi qui'
    }) placeholder: string;
    @Prop() value: string;
    @Prop() okCallback: (input: string) => Promise<any>;
    @Prop() koCallback: () => Promise<any>;

    input: string = "";

    created(){
        if(this.value){
            this.input = this.value;
        }
    }

    async ok(){
        if(this.okCallback){
            await this.okCallback(this.input);
        }
        this.$emit('close');
    }

    async ko(){
        if(this.koCallback){
            await this.koCallback();
        }
        this.$emit('close');
    }

}
